import Vue from 'vue';
import Router from 'vue-router';
import HomeView from '../views/HomeView.vue';
import PracticeView from '../views/PracticeView.vue';
import AddPracticeView from '../views/AddPracticeView.vue';
import ReportView from '../views/ReportView.vue';


Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/practice',
      name: 'practice',
      component: PracticeView,
    },
    {
      path: '/addpractice',
      name: 'addpractice',
      component: AddPracticeView
    },
    {
      path: '/report',
      name: 'report',
      component: ReportView
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 75 },
      };
    }
    return {
      x: 0,
      y: 0,
    };
  },
});

export default router;